import React from 'react';
import {
    Map as GoogleMap,
    // MapCameraChangedEvent,
    MapProps,
} from '@vis.gl/react-google-maps';
import { Coordinates } from '@bondvet/types';
import mapStyle from './mapStyle.json';

const supportsGoogleMaps = (): boolean => {
    return typeof HTMLDialogElement !== 'undefined';
};

const fallback = (
    <div style={{ width: '100vw', display: 'flex', padding: '16px 37px' }}>
        Google Maps is not supported in this browser.
    </div>
);

type GoogleMapProps = MapProps & {
    containerStyle: React.CSSProperties;
    coordinates: Coordinates[];
};

/* eslint-disable-next-line max-len */
// expected values: https://developers.google.com/maps/documentation/javascript/reference/coordinates#LatLngBoundsLiteral
// calculates the amounts to set the map within the boundaries of the coordinates passed
function calculateBounds(coordinates: Coordinates[]) {
    let north = -90;
    let south = 90;
    let east = -180;
    let west = 180;

    coordinates?.forEach((point) => {
        if (point?.latitude && point?.longitude) {
            if (point.latitude > north) north = point.latitude;
            if (point.latitude < south) south = point.latitude;
            if (point.longitude > east) east = point.longitude;
            if (point.longitude < west) west = point.longitude;
        }
    });

    // in cases where not enough coordinates are passed, using the average of the coordinates
    // zooms in too much. we adjust it using the expansionFactor. 0.02 roughly puts the
    // map on a city level
    const expansionFactor = 0.02;
    if (north - south < 0.01 && east - west < 0.01) {
        const averageLat = (north + south) / 2;
        const averageLng = (east + west) / 2;

        north = averageLat + expansionFactor;
        south = averageLat - expansionFactor;
        east = averageLng + expansionFactor;
        west = averageLng - expansionFactor;
    }

    return {
        north,
        south,
        east,
        west,
        // react-google-maps allows an optional padding property:
        /* eslint-disable-next-line max-len */
        // https://visgl.github.io/react-google-maps/docs/api-reference/components/map#defaultbounds-object
        padding: 50,
    };
}

function Map(props: GoogleMapProps) {
    const bounds = calculateBounds(props.coordinates);

    // const handleCameraChange = React.useCallback(
    //     (ev: MapCameraChangedEvent) => {
    //         // logic to update the search goes here
    //     },
    //     [],
    // );

    if (!supportsGoogleMaps()) {
        return fallback;
    }

    return (
        <GoogleMap
            style={props.containerStyle}
            defaultBounds={bounds}
            // onCameraChanged={handleCameraChange}
            mapTypeControl={false}
            // removes pegman
            streetViewControl={false}
            {...props}
            styles={mapStyle as google.maps.MapTypeStyle[]}
        >
            {props.children}
        </GoogleMap>
    );
}

export default Map;
